export enum ApiModule {
	AUTH = 'auth',
	CLIENT = 'client',
	EMPLOYEE = 'employee',
	DIETARY = 'dietary',
	ORDER = 'order',
	EXTERNAL_ORDER = 'external-order',
	LOGISTICS = 'logistics',
	SYSTEM = 'system',
}

export enum ApiAuthorization {
	EMPLOYEE = 'employee',
	CLIENT = 'client',
	PUBLIC = 'public',
}

export enum ApiDataModel {
	//auth
	INVITATIONS = 'invitations',
	EMPLOYEE = 'employee',
	CLIENT = 'client',
	PASSWORD_RESET = 'password-reset',
	FACILITIES = 'facilities',

	//users
	CLIENTS = 'clients',
	EMPLOYEES = 'employees',
	ROLES = 'roles',
	PERMISSIONS = 'permissions',
	ACCOUNT_STATUS = 'accountStatus',

	//employees
	TEAMS = 'teams',
	WALLETS = 'wallets',
	WALLET_LIMITS = 'wallet-limits',

	//diets
	DIETARY = 'dietary',
	ALLERGENS = 'allergens',
	MEAL = 'meal',
	MEALS = 'meals',
	MEAL_SIZE = 'meal-size',
	MEAL_VARIANT = 'variant',
	MEAL_VARIANTS = 'variants',
	MEALPREPS = 'mealpreps',
	SEMI_PRODUCT = 'semi-product',
	SEMI_PRODUCTS = 'semi-products',
	SEMI_PRODUCT_DETAILED = 'semi-product-detailed',
	MATERIALS = 'raw-material',
	MATERIALS_CATEGORY = 'raw-material-category',
	MEAL_PACKAGING = 'meal-packaging-types',
	NUTRITIONAL_PARAMETER = 'nutritional-parameters',
	FOOD_PRODUCTION_STAGE = 'food-production-stage',
	PRODUCTION_STAGES = 'production-stages',
	PRICE_TIER = 'meal-price-tier',
	DIET = 'diet',
	DIET_DAYS = 'diet-days',
	COMPONENTS = 'components',
	FILTER_TAGS = 'filter-tags',
	MARKETING_TAGS = 'marketing-tags',
	DIETARY_TAGS = 'dietary-tags',
	ADDONS = 'addons',
	RECIPE = 'recipe',
	MEAL_ADDON_CATEGORIES = 'meal-addon-categories',
	SIZE_MATRICES = 'meal-size-matrices',
	PRODUCTION_PLAN_MEALS = 'production-plan-meals',

	//orders
	ORDER = 'order',
	CARTS = 'carts',
	TRANSACTIONS = 'payments',
	CLIENT_DIET_DAYS = 'client-diet-days',
	CART_BLOCKED_DATES = 'cart-blocked-dates',
	BOXES = 'boxes',
	MEAL_CODES = 'meal-codes',
	DELIVERIES = 'deliveries',
	PACKAGES = 'packages',
	BOX_PACKAGINGS = 'box-packagings',
	INTERNAL_ORDERS = 'internal-orders',

	DIETS = 'diets',
	CLIENT_DIETS = 'client-diets',
	MEDIA = 'media',
	PRICES = 'prices',
	RATINGS = 'client-meal-ratings',
	ORDER_RATINGS = 'client-diet-ratings',

	ADDRESS = 'address',
	SCHEDULE = 'operations-schedule',
	SCHEDULE_BLACKLIST = 'operations-schedule-days-blacklist',

	// Loyalty, points
	LOYALTY = 'loyalty',
	LOYALTY_ACTIVITIES = 'loyalty-activities',
	LOYALTY_ACTIONS = 'loyalty-actions',
	LOYALTY_RULES = 'loyalty-rules',
	LOYALTY_TRANSACTIONS = 'loyalty-transactions',
	LOYALTY_POINTS = 'loyalty-points',
	LOYALTY_LEVELS = 'loyalty-levels',

	//promotions, codes, discounts
	PROMOTIONS = 'promotions',
	PROMOTION_ACTIONS = 'promotion-actions',
	PROMOTION_RULES = 'promotion-rules',
	COUPONS = 'coupons',
	INFLUENCERS_ANALYTICS = 'influencer-analytics',

	//campaigns module
	CAMPAIGNS = 'campaigns',
	CAMPAIGN_REPORTS = 'campaign-reports',
	DISCOUNT_CODE_REPORTS = 'discount-code-reports',
	DISCOUNT_CODES = 'discount-codes',
	B2B_CLIENTS = 'b2b-clients',
	CAMPAIGN_GOVERNANCE = 'governance',

	MESSAGE = 'client-messages',

	//production settings
	PRODUCTION_MACHINES = 'production-machines',
	PRODUCTION_SOCKETS = 'production-sockets',
	PRODUCTION_MACHINE_TYPES = 'types',
	PRODUCTION_PRODUCT_TYPES = 'product-types',
	MES_ERROR_REPORTS = 'production-issues',

	// fridge slots
	FRIDGE_SLOTS = 'fridge-slots',

	IMPERSONATE = 'impersonate',

	//gadgets
	GADGETS = 'gadgets',
	GADGETS_PARTNERS = 'gadget-partners',
	GADGETS_ORDERS = 'gadget-orders',
	GADGETS_CATEGORIES = 'gadget-categories',
	GADGETS_WAREHOUSES = 'gadget-warehouses',
	GADGETS_WAREHOUSE_STATUSES = 'gadget-warehouse-statuses',

	//system
	CACHE = 'cache',
	APP_VERSION = 'app-version',

	NEWSLETTER = 'newsletter',
}

export const createApiRoute = (module: ApiModule, ...rest: string[]) => {
	if (!rest.length) {
		return `${module}/api`
	}
	return `${module}/api/${rest.join('/')}`
}

export enum EApiSortType {
	ASC = 'asc',
	DESC = 'desc',
}
